var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"tooltipContainer",attrs:{"id":"tooltip-container"}},[_c('transition',{attrs:{"name":"fade"}},[(_vm.hoveredPoint)?_c('div',[_c('div',{staticClass:"tooltip"},[_c('p',[_vm._v(_vm._s(_vm.forestName))])])]):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }